import React, { Component } from 'react'
import PropTypes from 'prop-types'

import arraySort from 'array-sort'
import Item from './Item'

export default class QuestList extends Component {
  render() {
    const { dispatch, quests, showAllQuests } = this.props
    let questsSorted = arraySort(quests, ['name'])

    const questList = questsSorted.map(function (quest, index) {
      return (
        <Item
          quest={quest}
          showAllQuests={showAllQuests}
          position={index}
          key={index}
          dispatch={dispatch}
        />
      )
    })

    return <ul>{questList}</ul>
  }
}

QuestList.propTypes = {
  dispatch: PropTypes.func,
  quests: PropTypes.array,
  showAllQuests: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/topiccloud/subtopics/quests/List.js